import { AppState } from '../../bootstrap/redux/state/AppState';
import { LayoutType } from '../state/LayoutType';

export function selectLayoutType(state: AppState): LayoutType {
  return state.layoutType;
}
